export enum GridType {
  TAB = 'TAB',
  FORM = 'FORM',
  TAB_PANEL_CONTENT = 'TAB_PANEL_CONTENT',
  MESSAGE_CONTENT = 'MESSAGE_CONTENT'
}
